module.exports = __webpack_public_path__ + "img/termz2.a8ad755b.svg";